/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import styles from '~/shared/styles/HomLoader.module.css'

interface Props {
  rows?: number
  className?: string
  hideLogo?: boolean
}

export default function HouseOfMathLoaderSkeleton({ className, rows = 1, hideLogo }: Props): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])
  const background = 'bg-gradient-to-r from-orange-logo via-pink-logo to-blue-logo bg-clip-text'
  const text = 'select-none text-11 leading-none text-transparent text-center'
  const backgroundImage = `
    linear-gradient(
    90deg,
    rgba(255, 248, 248, 0) 0%,
    rgba(255, 248, 248, 0.1) 20%,
    rgba(255, 248, 248, 0.24) 50%,
    rgba(255, 248, 248, 0.1) 80%,
    rgba(255, 248, 248, 0) 100%
)
`

  return Array(rows)
    .fill()
    .map((_, i) => {
      return (
        <div
          className={`relative w-full h-full flex flex-col items-center justify-center overflow-hidden bg-white/30 ${className}`}
          key={i}
        >
          <div
            className="absolute inset-0 transform -translate-x-full"
            style={{ backgroundImage, animation: 'shimmer 600ms infinite' }}
          />
          {!hideLogo && (
            <SVGImage
              alt={t('imageAlt:icons.houseOfMath')}
              height={45}
              imageClassName="w-64"
              srcKey="logos/house-of-math.svg"
              width={234}
            />
          )}
          <section className="w-64">
            <div className="relative w-full h-12">
              <div className={`absolute inset-0 ${styles['hom-loader']}  ${styles['hom-loader-animate-dot-1']} `}>
                <div className={`${background} ${text}`}>
                  <span className="mr-12">&bull;</span>
                </div>
              </div>
              <div className={`absolute inset-0 ${styles['hom-loader']} ${styles['hom-loader-animate-dot-2']}`}>
                <div className={`${background} ${text}`}>
                  <span>&bull;</span>
                </div>
              </div>
              <div className={`absolute inset-0 ${styles['hom-loader']} ${styles['hom-loader-animate-dot-3']}`}>
                <div className={`${background} ${text}`}>
                  <span className="ml-12">&bull;</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    })
}
